import { useQuery } from "@tanstack/react-query";
import { getSalesOffices } from "../services/salesOfficeService";
import { getUserSalesOffices } from "../services/authService";

const useSalesOffices = () => useQuery({
    queryKey: ['salesOffices'],
    queryFn: () => {
        const offices = getUserSalesOffices();
        return getSalesOffices().then(res => 
            res.data.map(d => ({
                ...d,
                isOwnedByCurrentUser: offices.some(o => o === d.id)
            }))
        );
    },
    staleTime: 7 * 24 * 60 * 60 * 1000 // 1 week
});

export default useSalesOffices;